interface AvatarProps {
  name: string;
  size?: 'sm' | 'md';
}

const SIZE_CLASSES = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
};

function initialsFrom(name: string) {
  const parts = name.trim().split(/\s+/);
  const initials = parts.length > 1 ? `${parts[0][0]}${parts[1][0]}` : parts[0].slice(0, 2);
  return initials.toUpperCase();
}

export function Avatar({ name, size = 'md' }: AvatarProps) {
  return (
    <span
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full bg-accent-soft font-semibold text-primary-dark ${SIZE_CLASSES[size]}`}
    >
      {initialsFrom(name)}
    </span>
  );
}
